import { userSelectors } from "@fitness-app/app-store";
import {
  getPermissionScope,
  hasPermission,
  type PermissionKeyEnum,
  type PermissionScopeEnum,
} from "@fitness-app/data-models";

import { matchesPermissionRequirement, type PermissionRequirement } from "~/modules/Auth/permissionRequirement";
import { useAppSelector } from "~/store/initializeStore";

export const usePermissionScope = (permission: PermissionKeyEnum): PermissionScopeEnum => {
  const permissions = useAppSelector(userSelectors.getUserPermissions);
  return getPermissionScope(permissions, permission);
};

export const usePermission = (permission: PermissionKeyEnum, minimumScope?: PermissionScopeEnum): boolean => {
  const permissions = useAppSelector(userSelectors.getUserPermissions);
  return hasPermission(permissions, permission, minimumScope);
};

export const usePermissionRequirement = (requirement: PermissionRequirement): boolean => {
  const permissions = useAppSelector(userSelectors.getUserPermissions);
  return matchesPermissionRequirement(permissions, requirement);
};
